import { useTranslate } from 'react-admin';
import type { FieldMatchMode, KycOperationType, OcrTestResultStatus } from '@/types';

/** The words for the OCR-testing enums, in the reader's language. */
export const useOcrLabels = () => {
  const t = useTranslate();
  return {
    operationType: (id: KycOperationType) => t(`screens.ocrTesting.operationTypes.${id}`, { _: String(id) }),
    matchMode: (id: FieldMatchMode) => t(`screens.ocrTesting.matchModes.${id}`, { _: String(id) }),
    resultStatus: (id: OcrTestResultStatus) => t(`screens.ocrTesting.resultStatuses.${id}`, { _: String(id) }),
  };
};
